import { createRouter,createWebHistory} from 'vue-router'
import {getBaseURL} from "../../url_endpoints";
import {get_UPAYS_auth} from "@/components/hid";

function removeLocalStoragePaymentInfo() {
    localStorage.removeItem('aid')
    localStorage.removeItem('tid')
    localStorage.removeItem('pconfig')
    localStorage.removeItem('create_code')
    localStorage.removeItem('card_data')
    localStorage.removeItem('invoice_data')
}
const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue'),
    },
    {
        path: '/docs',
        name: 'Docs',
        component: () => import('../views/Docs.vue'),
    },
    {
        path: '/faq',
        name: 'FAQ',
        component: () => import('../views/FAQ.vue'),
    },
    {
        path: '/terms',
        name: 'Terms',
        component: () => import('../views/Terms.vue'),
    },
    {
        path: '/erase',
        component: () => import( '../views/403.vue'),
        beforeEnter(to, from, next) {
            let x = prompt('Confirm to erase your Account ?\nPlease enter your access code!')
            // check Access Code
            if(!x) {
                next(from)
            }else {
                next(403)
            }
        }
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import('../views/Privacy.vue'),
    },
    {
        path: '/pricing',
        name: 'Pricing',
        component: () => import('../views/Pricing.vue'),
    },
    {
        path: '/upays',
        name: 'Upays',
        component: () => import( '../views/403.vue'),
        beforeEnter(to, from, next) {
            alert('Browser Reload Unauthorized!');
            next('/401')
            removeLocalStoragePaymentInfo()
        }
    },
    { /*. Free plan */
        path:'/requesttrial',
        name:'RequestTrial',
        component:() => import('../views/RequestTrial.vue')
    },
    {
        path: '/configurator',
        name: 'Configurator',
        component: () => import( '../views/Configurator.vue'),
        beforeEnter(to, from, next) {
            const akey = localStorage.getItem('akey');
            if(!akey){
                alert('Not authorised!')
                next(from)
            }else {
                next()
            }
        }
    },
    {
       path: '/signin',
        name: 'SignIn',
        component: () => import( '../views/SignIn.vue'),
    },
    {
        path: '/signout',
        name: 'SignOut',
        component: () => import( '../views/Home.vue')
    },
    {
        path: '/hsso',
        name: 'HssoWithOutParams',
        component: () => import( '../views/HerokuConfigurator.vue'),
        beforeEnter(to, from, next) {
            alert('Unauthorized request: session information unavailable!')
            localStorage.removeItem('akey')
            localStorage.removeItem('heroku_app')
            localStorage.removeItem('plan')
            localStorage.removeItem('bid')
            localStorage.removeItem('client')
            next('/401')
        }
    },
    {
        path: '/hsso/:app/:id',
        name: 'Hsso',
        component: () => import( '../views/HerokuConfigurator.vue'),
        beforeEnter(to, from, next) {
            const heroku_app = to.params.app
            const akey = atob(to.params.id)
            localStorage.setItem('akey', akey)
            localStorage.setItem('heroku_app', heroku_app)
            /* first check consistency or send a error page*/
            const baseURL = getBaseURL()
            const auth = get_UPAYS_auth()
            let statusCode = 401
            fetch(baseURL+"/heroku/session?akey="+akey, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Authorization': `Basic ${auth}`,
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
            }).then(response => {
                switch(response.status){
                    case 401: statusCode = 401; break
                    case 404: statusCode = 404; break;
                    case 503: statusCode = 503; break;
                    default: statusCode = 500
                }
                return response.json()
            }).then( response =>{
                if(response['authorisation']){
                    localStorage.setItem('client',JSON.stringify(response['config']))
                    localStorage.setItem('plan',response['plan'])
                    /* if gold plan get business id for customers*/
                    if(response['plan'] ==='gold'){
                        localStorage.setItem('bid',response['bid'])
                    }
                    next()
                }else {
                    alert(response['error'])
                    next('/'+statusCode)
                }
            }).catch(() => {
                //console.log(error)
                next('/'+statusCode)
            })
        }
    },
    {
        path: '/403',
        name: '403',
        component: () => import( '../views/403.vue'),
        alias: ['/404','/401','/500','/503','/400','/402','/405']
    },
    {
        path: '/payment/:lang/:key/:unit/:stripe',
        name: 'Payment',
        component: () => import( '../views/Payment.vue'),
        beforeEnter(to, from, next) {
            let statusCode = 500
            const key = to.params.key
            let baseURL = getBaseURL()
            const auth = get_UPAYS_auth()
            /* add  pay flag for stats : count how many users click the payment page */
            fetch(baseURL+"/clients/auth?akey="+key+'&pay=1', {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Authorization': `Basic ${auth}`,
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
            }).then(response => {
                switch(response.status){
                    case 401: statusCode = 401; break
                    case 404: statusCode = 404; break;
                    default: statusCode = 500
                }
                return response.json()
            }).then( rsp => {
                if(rsp['auth']) {
                    /* save the config on local */
                    let pconfig = JSON.stringify(rsp['config'])
                    localStorage.setItem('pconfig',pconfig )
                    /* save the flag that generates customer keys*/
                    localStorage.setItem('create_code',rsp['c_keys'])
                    /* save the business id if needed to generate customer code*/
                    if(rsp['c_keys']) {
                        if( typeof rsp['aid'] !== 'undefined' ) {
                            localStorage.setItem('aid', JSON.stringify(rsp['aid']))
                        }
                        if(typeof rsp['tid'] !== 'undefined' ) {
                            localStorage.setItem('tid', JSON.stringify(rsp['tid']))
                        }
                    }
                    /* save temp info for stats*/
                    localStorage.setItem('payment_key',rsp['key'])
                    next()
                }else {
                    alert(rsp['message'])
                    next('/'+statusCode)
                }
            }).catch( err => {
                next('/'+statusCode)
                throw new Error('backend is down - '+err.message)
            })
        },
    },
    {
        path:'/preview/:p1/:p2/:p3',
        name:'Preview',
        component: () => import('../views/Preview.vue'),
        beforeEnter(to, from, next) {
            const preview = localStorage.getItem('preview_ups')
            if(!preview){
                next('/403')
            }else {
                localStorage.setItem('back_route',from.path)
                next()
            }
        }
    },
    {
        path:'/ckeys/:scope',
        name: 'CustoKeys',
        component: () => import( '../views/CustoKeys.vue')
    },
    {
        path:'/heroku',
        name:'Heroku',
        component: () => import( '../views/UpayHeroku.vue'),
        beforeEnter(to, from, next) {
            let pass = prompt('Please enter Admin Password')
            //console.log(pass)
            //console.log(btoa(`${pass}`))
            if(!pass) {
                next(from)
            }else {
                const pw = btoa(`${pass}`)
                if(pw === 'bWVlIGlzIGEgc3ltYm9s') {
                    next()
                }else {
                    next('/403')
                }
            }

        }
    },
    {
        path:'/authupays/:code',
        name: 'IntegrateAuth',
        component: () => import( '../views/IntegrateAuth.vue'),
        beforeEnter(to, from, next) {
            const key = localStorage.getItem('akey') ? localStorage.getItem('akey') : localStorage.getItem('tkey')
            if(to.params.code ===  key) {
                next()
            }else {
                next('/403')
            }
        }
    }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})



export default router
